<template>
<section

            id="mainContent"
            class="home"
            :class="fullHeight"
            :style="{backgroundImage: `url(${$store.state.clientConfig.directoryUrl}/img/background.jpg)`, backgroundRepeat: 'no-repeat', backgroundSize: 'cover',backgroundPosition: 'bottom'}"
        >
            <div
                class="overlay-colour"
            ></div>


                <div class="container">
                    <div class="row">
                    <div class="col-md-7 col-sm-12 intro">
                        <h1>Welcome to the LCP Member Portal</h1>

                        <transition name="fade" mode="out-in">
                            <div v-if="!showAuthRequirements" key="submissionId">
                                <div class="error" v-if="sessionExpired">
                                    <p class="error-message">
                                        Your session has automatically timed out, please log in again to complete the form. Any information you may have filled out has been automatically saved.
                                    </p>
                                </div>
                                <p>Please enter your LCP submission ID given to you by our Team.</p>
                                <div class="submissionWrapper" :class="{'error': $v.submissionId.$error}">
                                    <input class="form-control submissionId" type="text" placeholder="eg. SOAEUAWLQTH" v-model="submissionId"
                                    @keyup.enter="showSecurity"/>
                                    <template v-if="$v.submissionId.$dirty">
                                        <div class="error-message" v-if="!$v.submissionId.required">Field is required</div>
                                    </template>
                                </div>
                                <button
                                    class="button-outline-rounded pension"
                                    @click="showSecurity"
                                >Submit</button>
                            </div>
                            <div v-if="showAuthRequirements" key="authRequirements">
                                <p>Please enter the security details below</p>
                                <div class="niNumberWrapper" :class="{'error': $v.niNumber.$error}">
                                    <label>Member's National Insurance No.</label>
                                    <input class="form-control niNumber" type="text" placeholder="AB121212A"
                                    maxlength="9" v-model.trim="niNumber"/>
                                    <template v-if="$v.niNumber.$dirty">
                                        <div class="error-message" v-if="!$v.niNumber.required">Field is required</div>
                                        <div class="error-message" v-if="!$v.niNumber.minLength">Min 8 characters</div>
                                    </template>
                                </div>
                                <label>Member's Date of Birth</label>
                                <date-dropdown min="1900" max="2010" default="1991-07-31" v-model="dob" class="dateDropdown" :class="{'error': !dobValid}" />
                                <div class="terms"  :class="{'error': $v.termsAgreed.$error}">
                                    <p-check class="termsAgreedCheckbox p-default" name="check" color="info" v-model="termsAgreed">
                                        <label slot="off-label"></label>
                                    </p-check>
                                    <label>I agree to the <router-link to="/submissions/legal/terms" target="_blank">terms &amp; conditions</router-link></label>
                                    <template v-if="$v.termsAgreed.$dirty">
                                        <div class="error-message" v-if="!$v.termsAgreed.isTrue">Terms must be agreed</div>
                                    </template>
                                </div>

                                <div v-if="securityFailed && isLockedOutNextLogin" class="securityFailed animated pulse">Security failed. Form will be locked after 5 failed attempts to enter correct details</div>
                                <div v-else-if="securityFailed && isLockedOut" class="securityFailed animated pulse">Security failed. Form has been locked due to too many invalid login attempts. Please contact the LCP team to unlock</div>
                                <div v-else-if="securityFailed" class="securityFailed animated pulse">Security failed. Please check your answers</div>

                                <button
                                    class="button-outline-rounded pension"
                                    @click="checkSecurity"
                                >{{checkingSecurityButton}}</button>
                                <div class="link">
                                    <span  @click="goBack()"><i class="icon-arrow-left"/> Back</span>
                                </div>
                            </div>
                        </transition>


                    </div>

                </div>
                </div>

        </section>
</template>

<script>
import DateDropdown from 'vue-date-dropdown';
import axios from 'axios';
import { required, minLength } from 'vuelidate/lib/validators';
import { submissionState, updateSubmissionState } from '@/observables/submissions';

const publicCode = process.env.VUE_APP_PUBLICAPICODE;
const apiUrlPublic = process.env.VUE_APP_APIADDRESSPUBLIC;

export default {
    data () {
        return {
            submissionId: process.env.NODE_ENV === 'development' ? 'SOWJRNIUTH' : '',
            niNumber: process.env.NODE_ENV === 'development' ? 'AA000000A' : '',
            dob: '',
            termsAgreed: process.env.NODE_ENV === 'development',
            showAuthRequirements: false,
            checkingSecurity: false,
            securityFailed: false,
            isLockedOut: false,
            isLockedOutNextLogin: false,
            dobValid: true,
        };
    },
    validations: {
        niNumber: {
            required,
            minLength: minLength(8),
        },
        submissionId: {
            required,
        },
        termsAgreed: {
            isTrue (termsAgreed) {
                return (
                    termsAgreed === true
                );
            },
        },
    },
    created () {
        if (submissionState.form.submissionId) {
            this.submissionId = submissionState.form.submissionId;
            if (this.submissionId.startsWith('SSQ-')) {
                if (!this.$route.query.logout) {
                    this.feedbackBypass();
                }
            } else {
                this.showAuthRequirements = true;
            }
        }
    },
    components: { DateDropdown },
    computed: {
        clientConfig () {
            return this.$store.getters['clientConfig/clientConfig'];
        },
        fullHeight () {
            return this.$store.state.ui.showFooter ? '' : 'full-home-height';
        },
        homepageOverrides () {
            return this.clientConfig.homepage;
        },
        checkingSecurityButton () {
            return (this.checkingSecurity ? 'Validating please wait...' : 'Submit');
        },
        sessionExpired () {
            return this.$store.getters['auth/getSessionExpired'] || this.$route.query.sessionExpired;
        },
    },
    methods: {
        feedbackBypass () {
            // bypass the ni and dob with generic details which will match on the backend. This will prevent the check screen showing and take them stratight through
            this.niNumber = 'AA123456Z';
            this.dob = '1947-01-01';
            axios.post(`${apiUrlPublic}/Login?code=${publicCode}`, {
                WebId: this.submissionId.toLowerCase(),
                NINumber: this.niNumber.toLowerCase(),
                DateOfBirth: this.dob,
            }).then((response) => {
                this.dob = '01-01-1947';
                this.nextStep(response.data);
                this.checkingSecurity = false;
                this.$v.$reset();
            });
        },
        goBack () {
            this.niNumber = '';
            this.dob = '';
            this.termsAgreed = false;
            this.showAuthRequirements = false;
            // added post live to reset message after pressing back
            this.securityFailed = false;
            this.isLockedOut = false;
            this.isLockedOutNextLogin = false;
        },
        showSecurity () {
            this.$v.$touch();
            if (!this.$v.submissionId.$error) {
                if (this.submissionId.startsWith('SSQ-')) {
                    this.feedbackBypass();
                } else {
                    this.showAuthRequirements = true;
                    this.$v.$reset();
                }
            }
        },
        checkSecurity () {
            this.$v.$touch();
            const dob = this.$moment(this.dob, 'DD-MM-YYYY');
            if (!this.$v.$invalid && this.dobValid) {
                this.checkingSecurity = true;
                const formattedDob = dob.format('YYYY-MM-DD');

                axios.post(`${apiUrlPublic}/Login?code=${publicCode}`, {
                    WebId: this.submissionId.toLowerCase(),
                    NINumber: this.niNumber.toLowerCase(),
                    DateOfBirth: formattedDob,
                }).then((response) => {
                    this.nextStep(response.data);
                    this.checkingSecurity = false;
                    this.$v.$reset();
                });
            }
        },
        nextStep (loginResponse) {
            if (loginResponse.loggedIn) {
                updateSubmissionState.setupAccess(loginResponse.loggedIn, {
                    WebId: this.submissionId.toLowerCase(),
                    NINumber: this.niNumber.toLowerCase(),
                    DateOfBirth: this.$moment(this.dob, 'DD-MM-YYYY').format('YYYY-MM-DD'),
                });
                this.$router.push(`/submissions/${this.submissionId.toUpperCase()}`);
            } else {
                this.securityFailed = true;
                this.isLockedOut = loginResponse.lockedOut;
                this.isLockedOutNextLogin = loginResponse.lockedOutNextLogin;
            }
        },
    },
    watch: {
        dob (newval) {
            const dob = this.$moment(newval, 'DD-MM-YYYY');
            this.dobValid = dob.isValid(); // Should change to this
            // dob.isValid() ? this.dobValid = true : this.dobValid = false;
        },
    },
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/_mixins.scss";
.home {
    height: calc(100vh - 50px);
    position: relative;
    display: flex;
    align-items: center;
    overflow: auto;
    &.full-home-height {
        min-height: 100vh !important;
        transition: min-height 0.3s ease-in-out;
    }
    @include responsive("md") {
        min-height: 100vh;
        overflow: auto;
        position: absolute;
        left: 0;
        right: 0;
        top: 70px;
        bottom: 0;
        display: block;
        padding-bottom: 140px;
        padding-top:100px;

    }
    @include responsive("sm") {
        min-height: 100vh;
        overflow: auto;
        position: absolute;
        left: 0;
        right: 0;
        top: 70px;
        bottom: 0;
        display: block;
        padding-bottom: 140px;
        padding-top:0;
    }

    &:after{
        content:'';
        background-image: var(--homepageFooter);
        background-size: 100% 100px;
        bottom: 0;
        height: 100px;
        left:0;
        z-index: 1;
        display: block;
        position: absolute;
        width: 100%;
        pointer-events: none;
        @include responsive("sm") {
            position: fixed;
        }
        @include responsive("md") {
            position: fixed;
        }
    }
    .tesla-bg {
        position: absolute;
        z-index: -1;
        top: 0px;
        &.bg-img {
            max-width: 100%;
        }
    }
    .overlay-colour {
        position: absolute;
        top: 0;
        z-index: 0;
        background: rgb(255,255,255);
background: linear-gradient(90deg, rgba(255,255,255,1) 0%, rgba(0,0,0,0) 100%);
        width: 100%;
        bottom: 0;
    }
    .divider-shape {
        background-image: url("data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTAwJSIgaGVpZ2h0PSIxMDBweCIgdmlld0JveD0iMCAwIDEyODAgMTQwIiBwcmVzZXJ2ZUFzcGVjdFJhdGlvPSJub25lIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPjxnIGZpbGw9IiNmZmZmZmYiPjxwYXRoIGQ9Ik0xMDk0LjQ0IDExOUwxNzIuNyA2OC43MmE3NC41NCA3NC41NCAwIDAgMS0yNS4xOS01Ljk1TDAgMHYxNDBoMTI4MFYwbC0xMzMuODUgMTAyYy0xNS44NCAxMi4wOS0zMy43IDE3Ljk1LTUxLjcxIDE3eiIgZmlsbC1vcGFjaXR5PSIuNSIvPjxwYXRoIGQ9Ik0xMDkzLjQ4IDEzMS44NUwxNzMgOTRhNzYuODUgNzYuODUgMCAwIDEtMzYuNzktMTEuNDZMMCAwdjE0MGgxMjgwVjBsLTEzMS44MSAxMTEuNjhjLTE2LjQ3IDEzLjk2LTM1LjQ3IDIwLjk2LTU0LjcxIDIwLjE3eiIvPjwvZz48L3N2Zz4=");
        background-size: 100% 100px;
        bottom: 0;
        height: 100px;
        z-index: 1;
        display: block;
        position: absolute;
        width: 100%;
        pointer-events: none;
        // background-repeat-y: no-repeat;
        @include responsive("sm") {
            display: none;
        }
    }

    ::v-deep.intro {
        // margin-top: 180px;
        color: black;

        z-index:1;
        align-self: center;
        @include responsive("sm") {
            margin-top: 20px;
            padding: 40px !important;
            margin-bottom: 40px;
        }

        h1 {
            margin-bottom: 30px;
            width: 80%;
            color: var(--secondaryColour);
            // text-shadow: 1px 2px 3px rgba(0, 0, 0, 0.2);
        }
        p {
            font-size: 18px;
            line-height: 26px;
            // text-shadow: 1px 2px 3px rgba(0, 0, 0, 0.2);
        }
        .button-outline-rounded {
            border: 2px solid var(--secondaryColour);
            color: var(--textOnSecondary);
            background: var(--secondaryColour);
            padding: 10px 40px;
            text-transform: uppercase;
            display: inline-block;
            border-radius: 30px;
            cursor: pointer;
            &:hover {
                opacity: .8;
                color: var(--textOnPrimary);
            }
            &.pension {
                margin-right: 20px;
            }
            &.contact {
                padding: 10px;
            }
        }
    }
    .carousel{
        z-index:1;

    }
    .submissionId, .niNumber{
        width: 300px;
        margin:10px 0 20px 0;
        padding: 12px;
        font-size: 20px;
        text-transform:uppercase;
        &::placeholder{
            color: lightgray;
        }
    }
    ::v-deep.date-dropdown-select{
        padding:12px;
        &:focus{
            color: #495057;
            background-color: #fff;
            border-color: #80bdff;
            outline: 0;
            -webkit-box-shadow: 0 0 0 0.2rem rgba(0,123,255,.25);
            box-shadow: 0 0 0 0.2rem rgba(0,123,255,.25);
        }
    }
    .dateDropdown{
        margin-bottom: 20px;
        &.error{
            ::v-deepselect{
                border-color: $red;
            }
        }
    }
    .error{
        .error-message{
            margin-top: -15px;
            font-size: 14px;
            margin-bottom: 10px;
            color:$red;
        }
        .form-control {
            border-color: $red;
        }
    }
    .securityFailed{
        background: $red;
        padding:10px 20px;
        color:white;
        margin-bottom: 10px;
        width: 300px;
        border-radius: 6px;
        font-size:14px;
    }
    .link{
        margin-top:10px;
        cursor:default;
        span{
            display: inline-block;
            cursor: pointer;
        }
    }
    .terms{
        .termsAgreedCheckbox{
            margin-bottom:20px;
        }
        ::v-deep.pretty .state label:before, {
            top:0;
        }
        ::v-deep.pretty .state label:after{
            top:0;
        }
    }
}
</style>
